import React, { useState, useEffect, useRef } from "react";
import LcAccordion from "../../../../../components/Generic/LcAccordion";
import { Rating } from "react-simple-star-rating"
import "./index.css";
import SurveyCustomerService from "../../../../../services/SurveyCustomerService/SurveyCustomerService";
import LcLoading from "../../../../../components/Generic/LcLoading";
import AlertNotification, { AlertColor } from "../../../../../components/Dialog/AlertNotification";
import TextTools from "../../../../../services/TextTools/TextTools";
import { PPTextField } from "processor-plataform-ui";

interface Props {
    solicitation: any
    user: any
    getSolicitationsType?: Function
}

const SolicitationDetailsRating: React.FC<Props> = (props) => {
    const surveyCustomerService = new SurveyCustomerService(props);
    const util = new TextTools();
    const [rating, setRating] = useState<number>(0);
    const [detailing = "", setDetailing] = useState<string>();
    const [surveyCustomer, setSurveyCustomer] = useState<any>();
    const [disableEvaluation, setDisableEvaluation] = useState<boolean>(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [initialRating, setInitialRating] = useState<number>(0);
    const [openNotificacao, setOpenNotificacao] = useState<boolean>(false);
    const [severity, setSeverity] = useState<AlertColor>("info");
    const [message, setMessage] = useState<string>("");
    const [justificar, setJustificar] = useState<boolean>(false);

    const messagesEndRef = useRef<any>(null);

    const notificationWarningValidation = (mensagem: string) => {
        setMessage(mensagem);
        setSeverity("warning");
        setOpenNotificacao(true);
    }

    useEffect(() => {
        if (props.solicitation) {
            setDisableEvaluation(true);
            setSurveyCustomer([]);
            setDetailing("");
            setRating(0);
            setInitialRating(0);

            setSurveyCustomer({
                id: props.solicitation.id,
                responseRating: 0,
                description: "",
                responseDate: null,
                idUser: props.user.id
            });

            const dataMonths = util.getMomentDiff(props.solicitation.endDate, "months");

            if (props.solicitation.satisfactionSurveyRespond === 0 && dataMonths < 1) setDisableEvaluation(false);

            retriveRating(props.solicitation.id);
        }
    }, [props.solicitation]);

    const retriveRating = async (solicitationId: number) => {

        setLoading(true);

        try {
            const surveyResponse = await surveyCustomerService.retrieveSurveyCustomer(solicitationId);

            if (surveyResponse.data && surveyResponse.data.length > 0) {
                setSurveyCustomer(surveyResponse.data[0]);
                setInitialRating(surveyResponse.data[0].responseRating);
                setDisableEvaluation(true);
                setDetailing(surveyResponse.data[0].description);
            }
        }
        catch (error) {

        }

        setLoading(false);
    }

    const onChangeDetailing = (e: any) => setDetailing(e.target.value);
    const handleRating = (rating: number) => setRating(rating);

    const handleClick = async () => {
        if (rating === 0) {
            notificationWarningValidation("Preencha uma avaliação válida!");
            return;
        }
        else if (rating <= 3 && detailing.length <= 5) {
            setJustificar(true);
            return;
        }
        else {
            setJustificar(false);
        }

        setLoading(true);

        let _surveyCustomer = {
            ...surveyCustomer,
            responseRating: rating,
            description: detailing,
        }

        try {
            await surveyCustomerService.saveSurveyCustomer(_surveyCustomer);
            retriveRating(props.solicitation.id);
            props.getSolicitationsType && props.getSolicitationsType();
        }
        catch (error) {
            console.warn(error);
        }

        setLoading(false);
    }

    const tooltipArray = [
        "Ruim",
        "Regular",
        "Bom",
        "Muito Bom",
        "Excelente",
    ]

    const handleCancel = () => {
        setDetailing("");
        setRating(0);
        setInitialRating(0);
        setJustificar(false);
    }

    const handleCloseNotification = () => setOpenNotificacao(false);

    const handleScroll = () => {
        messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    }

    return (
        <>
            {
                props.solicitation.idStatus === 8 &&
                <>
                    {
                        (window.screen.width > 600)
                            ? <div className={"divOrderDetailsRatingGeral"}>
                                <LcAccordion title={"Avaliação"} visible={!disableEvaluation} iconNormal={true} >
                                    <LcLoading loading={loading} label={"Carregando..."}>
                                        <span className={"spanProprietiesNormalDetailsRating"} style={{ marginLeft: "5px" }}> Como você avalia esse atendimento? </span>
                                        <div className={"divOrderRating"}>
                                            <Rating
                                                onClick={handleRating}
                                                showTooltip={true}
                                                tooltipDefaultText={""}
                                                tooltipArray={tooltipArray}
                                                tooltipStyle={{
                                                    // position: "absolute",
                                                    display: "flex",
                                                    flexDirection: "row",
                                                    flexWrap: "wrap",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    width: "100%",
                                                    color: "#8B90A3",
                                                    backgroundColor: "#E2E6F3",
                                                    fontFamily: "Inter",
                                                    fontSize: "12px",
                                                    margin: "0px",
                                                    minHeight: '25px'
                                                }}
                                                initialValue={initialRating}
                                                readonly={disableEvaluation}
                                                allowHover={false}
                                                transition={false}
                                                iconsCount={5}
                                            />
                                        </div>

                                        <div className={"divOrderTextArea"}>
                                            <span className={"spanJustificar"} style={{ display: justificar ? "block" : "none" }}>{
                                                (detailing.length === 0)
                                                    ? "Justifique sua avaliação"
                                                    : "A justificativa deve conter mais do que 5 caracteres"

                                            }</span>
                                            <PPTextField
                                                required={rating < 4}
                                                multiline={!disableEvaluation}
                                                minRows={5}
                                                maxRows={5}
                                                placeholder={(disableEvaluation) ? "" : "Justifique sua avaliação"}
                                                className={"textAreaRating"}
                                                onChange={onChangeDetailing}
                                                value={detailing}
                                                disabled={disableEvaluation}
                                            />
                                        </div>

                                        {
                                            !disableEvaluation &&
                                            <>
                                                <button type="button" className={"lc-button bg-info small"} onClick={() => handleClick()} style={{ width: "100px", margin: "10px 10px 0px 5px" }}> Enviar </button>
                                                <button type="button" className={"lc-button bg-info-alt small"} onClick={() => handleCancel()} style={{ width: "100px" }}> Cancelar </button>
                                            </>
                                        }
                                        <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={handleCloseNotification} />
                                    </LcLoading>
                                </LcAccordion>
                            </div>
                            : <div className={"ratingMobile"}>
                                <span className={"spanProprietiesNormalDetailsRatingMobile"}> Como você avalia esse atendimento? </span>
                                <div className={"divOrderRating"}>
                                    <Rating
                                        onClick={handleRating}
                                        showTooltip={true}
                                        tooltipDefaultText={""}
                                        tooltipArray={tooltipArray}
                                        tooltipStyle={{
                                            display: "flex",
                                            flexDirection: "row",
                                            flexWrap: "wrap",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            width: "100%",
                                            color: "#8B90A3",
                                            backgroundColor: "transparent",
                                            fontFamily: "Inter",
                                            fontSize: "14px",
                                            marginLeft: "0px"
                                        }}
                                        initialValue={initialRating}
                                        readonly={disableEvaluation}
                                        allowHover={false}
                                        transition={false}
                                        iconsCount={5}

                                    />
                                </div>

                                <div className={"divOrderTextArea"}>
                                    {/* <span className="spanJustificar" style={{display: justificar? "block": "none"}}>
                                        {detailing.length === 0 ?  "Justifique sua avaliação" : "A justificativa deve conter mais do que 15 caracteres"}
                                    </span> */}
                                    <div ref={messagesEndRef} onClick={() => handleScroll()}>
                                        <PPTextField
                                            required={rating < 4}
                                            multiline
                                            minRows={5}
                                            maxRows={5}
                                            placeholder={(disableEvaluation) ? "" : "Justifique sua avaliação"}
                                            className={"textAreaRating"}
                                            onChange={onChangeDetailing}
                                            value={detailing}
                                            disabled={disableEvaluation}
                                        />
                                    </div>
                                </div>
                                <span className={"spanJustificar"} style={{ color: (justificar) ? "red" : "#2B304F", opacity: (justificar) ? "1" : "0.5" }}>
                                    Minimo de 5 caracteres
                                </span>
                                {
                                    !disableEvaluation &&
                                    <div className={"btnMobileAction"}>
                                        <button type={"button"} className={"lc-button bg-info small"} onClick={() => handleClick()} style={{ width: "61px", height: "40px", margin: "10px 10px 0px 5px" }}> Ok </button>
                                    </div>
                                }
                                <AlertNotification open={openNotificacao} severity={severity} message={message} handleClose={handleCloseNotification} />
                            </div>
                    }
                </>
            }
        </>
    );
};

export default SolicitationDetailsRating;